import { z } from 'zod'
import { REQUIRED_BASIC_MESSAGE } from '../constants/constants'

export const YesOrNoSchema = z.union([
  z.literal('Yes', { message: 'Required' }),
  z.literal('No', { message: 'Required' }),
])
export type YesOrNo = z.infer<typeof YesOrNoSchema>

export const ZipCodeSchema = z
  .string({
    message: REQUIRED_BASIC_MESSAGE,
  })
  .regex(/^\d{5}(?:[-\s]\d{4})?$/, REQUIRED_BASIC_MESSAGE)

export const USStateSchema = z.string().min(1, REQUIRED_BASIC_MESSAGE)

export const RequiredStringSchema = z
  .string({
    message: REQUIRED_BASIC_MESSAGE,
  })
  .min(1, REQUIRED_BASIC_MESSAGE)

export const AtleastOneArraySchema = z
  .array(z.string())
  .min(1, 'At least one option is required')

export const USPhoneNumberSchema = z
  .string()
  .regex(/^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/)

export const EmailSchema = z.string().email()
